var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelTrainingBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 338,
    viewBox: "0 0 483 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.384 1H7C3.68629 1 1 3.68629 1 7V331C1 334.314 3.6863 337 7.00001 337H363.384C366.697 337 369.384 334.314 369.384 331V205C369.384 201.686 372.07 199 375.384 199H443C446.314 199 449 196.314 449 193V155.5C449 152.186 446.314 149.5 443 149.5H375.384C372.07 149.5 369.384 146.814 369.384 143.5V7C369.384 3.68629 366.697 1 363.384 1Z",
    fill: "url(#paint0_linear_2626_3508)",
    stroke: "url(#paint1_linear_2626_3508)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M449.708 174.534C448.743 173.7 447.38 173.505 446.22 174.035C445.06 174.566 444.316 175.724 444.316 177V187.376H415C413.2 187.376 411.74 188.836 411.74 190.636V211.848C411.74 213.649 413.2 215.108 415 215.108H444.316V225.485C444.316 226.761 445.06 227.919 446.22 228.45C447.38 228.98 448.743 228.785 449.708 227.951L477.739 203.708C478.455 203.089 478.866 202.189 478.866 201.242C478.866 200.296 478.455 199.396 477.739 198.777L449.708 174.534Z",
    fill: "#031D60",
    stroke: "white",
    strokeWidth: 6.52,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M449.708 122.534C448.743 121.7 447.38 121.505 446.22 122.035C445.06 122.566 444.316 123.724 444.316 125V135.376H415C413.2 135.376 411.74 136.836 411.74 138.636V159.848C411.74 161.649 413.2 163.108 415 163.108H444.316V173.485C444.316 174.761 445.06 175.919 446.22 176.45C447.38 176.98 448.743 176.785 449.708 175.951L477.739 151.708C478.455 151.089 478.866 150.189 478.866 149.242C478.866 148.296 478.455 147.396 477.739 146.777L449.708 122.534Z",
    fill: "#031D60",
    stroke: "white",
    strokeWidth: 6.52,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2626_3508",
    x1: 225,
    y1: 1,
    x2: 225,
    y2: 337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68AEFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68AEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2626_3508",
    x1: 327.214,
    y1: 0.999898,
    x2: 83.8989,
    y2: 14.0414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#7E30E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#0072F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#67ADFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTrainingBackground);
export default __webpack_public_path__ + "static/media/model-training-background.93e7a90f5917bdbe744d2822168f8dc0.svg";
export { ForwardRef as ReactComponent };